import * as React from 'react';

var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPaymentCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 11.5 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 11.5H8a2 2 0 00-2 2v17a2 2 0 002 2h28a2 2 0 002-2v-17a2 2 0 00-2-2z",
    fill: "#E6F4EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.002 29a7.056 7.056 0 007.11-7 7.056 7.056 0 00-7.11-7 7.056 7.056 0 00-7.111 7A7.056 7.056 0 0022 29z",
    fill: "#80C594"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.199 21.358c-1.189-.344-1.572-.7-1.572-1.254 0-.636.529-1.079 1.415-1.079a1.147 1.147 0 011.314 1.225h1.158a2.276 2.276 0 00-1.682-2.223V16.75H21.26v1.26a2.185 2.185 0 00-1.833 2.106c0 1.347 1 2.018 2.462 2.409 1.31.35 1.572.863 1.572 1.406 0 .4-.257 1.044-1.415 1.044-1.079 0-1.503-.537-1.561-1.225h-1.153a2.344 2.344 0 001.928 2.234v1.266h1.572v-1.254a2.068 2.068 0 001.834-2.071c0-1.657-1.273-2.223-2.467-2.567z",
    fill: "#E6F4EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32.5H8a2 2 0 01-2-2v-17a2 2 0 012-2h28a2 2 0 012 2v17a2 2 0 01-2 2zM8.143 12.812a1 1 0 00-1 1v16.376a1 1 0 001 1h27.715a1 1 0 001-1V13.812a1 1 0 00-1-1H8.143z",
    fill: "#80C594"
  })));
}

export { SvgPaymentCash as ReactComponent };
